export enum ApiLoadingTypes {
  IS_LOADING = 'is-loading',
  HAS_ERROR = 'has-error',
  HAS_DATA = 'has-data',
}
